import { Add, Remove } from '@mui/icons-material'
import { Box, Button, FormHelperText, OutlinedInput, Typography } from '@mui/material'

export default function IncreaseDecreaseInput({
    name,
    value,
    onChange,
    adornment,
    decimal = true,
    max,
    label,
    labelColor = "black",
    error,
    ...props
}) {

    const handleChange = ({ target: { name, value } }) => {
        if (value === '+' || value === '-' || value === "00") {
            return;
        }
        let regex = /^[0-9]+\.?[0-9]*$/
        if (decimal === false) {
            regex = /^[1-9][0-9]*$/
        }
        if (value === '' || (value.match(regex))) {
            if (!!max && Number(value) > max) {
                return
            }
            onChange({ target: { name, value } })
        }
    }

    const increaseHandler = () => {
        let data = Number(value) + 1
        if (!!max && data > max) return
        onChange({ target: { name, value: data } })
    }

    const decreaseHandler = () => {
        let data = Number(value) - 1
        if (data <= 0) return
        onChange({ target: { name, value: data } })
    }

    return (
        <Box display="flex" flexDirection="column">
            <Typography variant="subtitle1">{label} <span style={{ color: labelColor }}>*</span></Typography>
            <Box display="flex">
                <Button
                    onClick={increaseHandler}
                    variant="outlined"
                    sx={{
                        minWidth: 35,
                        px: 0.5,
                        borderRight: "unset",
                        borderRadius: "4px 0px 0px 4px",
                        borderColor: "#0000003b"
                    }}
                >
                    <Add sx={{ fontSize: 20, color: "black" }} />
                </Button>
                <OutlinedInput
                    name={name}
                    value={value}
                    onChange={handleChange}
                    endAdornment={<Typography variant="subtitle2" sx={{ paddingLeft: 0.5 }}>{adornment}</Typography>}
                    size="small"
                    sx={{
                        fontSize: 14,
                        boxSizing: 'border-box',
                        paddingY: 0.4,
                        borderRadius: "0px",
                        textAlign: "center",
                        height: 40, // Set the height to 20px
                        '& input': {
                            textAlign: 'center' // Ensure the input text is centered
                        },
                        '&.MuiInputBase-adornedEnd': {
                            pr: "7px !important",
                        }
                    }}
                    error={!!error}
                    {...props}
                />
                <Button
                    onClick={decreaseHandler}
                    variant="outlined"
                    sx={{
                        minWidth: 35,
                        px: 0.5,
                        borderLeft: "unset",
                        borderRadius: "0px 4px 4px 0px",
                        borderColor: "#0000003b"
                    }}
                >
                    <Remove sx={{ fontSize: 20, color: "black" }} />
                </Button>
            </Box>
            <FormHelperText error={!!error}>{error ?? ''}</FormHelperText>
        </Box>
    )
}
